export default __webpack_public_path__ + "static/media/Torpedo.7c745fd6.jpg";